export function initMenu() {
  // Properly update the ARIA states on focus (keyboard) and mouse over events
  var menuBarItems = document.querySelectorAll(
    '[role="menubar"] [aria-haspopup="true"]'
  );
  menuBarItems.forEach(function (item) {
    item.addEventListener("focus", function () {
      this.setAttribute("aria-expanded", "true");
    });
    item.addEventListener("mouseenter", function () {
      this.setAttribute("aria-expanded", "true");
    });
  });

  // Properly update the ARIA states on blur (keyboard) and mouse out events
  menuBarItems.forEach(function (item) {
    item.addEventListener("blur", function () {
      this.setAttribute("aria-expanded", "false");
    });
    item.addEventListener("mouseleave", function () {
      this.setAttribute("aria-expanded", "false");
    });
  });

  // Expand menus with keyboard (Enter or Spacebar)
  document.addEventListener("keydown", function (event) {
    if (event.key === "Enter" || event.key === " ") {
      var focusedItem = document.activeElement;
      if (focusedItem && focusedItem.getAttribute("aria-haspopup") === "true") {
        focusedItem.setAttribute("aria-expanded", "true");
      }
    }
  });

  // Enable submenu navigation with Tab and Arrow keys
  var parentMenuItems = document.querySelectorAll(
    '.header__main-list li[aria-haspopup="true"]'
  );
  parentMenuItems.forEach(function (parentItem) {
    parentItem.addEventListener("keydown", function (event) {
      if (event.key === "ArrowDown") {
        event.preventDefault();
        var subMenu = this.querySelector(".sub-menu");
        if (subMenu) {
          var firstChildMenuItem = subMenu.querySelector("li");
          if (firstChildMenuItem) {
            firstChildMenuItem.focus();
          }
        }
      }
    });
  });

  //Mobile Menu
  const mediaQuery = window.matchMedia("(max-width: 960px)");

  if (mediaQuery.matches) {
    const mobileOpenButton = document.getElementById("mobile-menu-button");
    const itemsWithChildren = document.querySelectorAll(".menu-item-has-children");
    const subMenu = document.querySelectorAll(".sub-menu");
    const mobileCloseButton = document.getElementById("mobile-menu-close");
    const mobileMenu = document.querySelector(".header__left-container");

    window.onload = function () {
      subMenu.forEach((e) => {
        e.classList.add("hide-mobile");
      });
    };

    mobileOpenButton.addEventListener("click", () => {
      mobileMenu.classList.toggle("hide-mobile");
      document.body.classList.toggle("menu-open");
    });

    mobileCloseButton.addEventListener("click", () => {
      mobileMenu.classList.toggle("hide-mobile");
      document.body.classList.toggle("menu-open");
    });

    itemsWithChildren.forEach((item) => {
      item.addEventListener("click", () => {
        const submenu = item.querySelector(".sub-menu");

        if (submenu) {
          submenu.classList.toggle("hide-mobile");
          item.classList.toggle("rotate");
        }
      });
    });
  }
}
